export interface CityGenericItem {
    city_id: number
    city_name: string
    flag_active: boolean
}

export interface CityOption {
    label: string
    value: string
}

export const getActiveCityOptions = (
    cities: CityGenericItem[] | undefined | null,
    currentCityId?: number | string | null
): CityOption[] => {
    const currentId = currentCityId ? String(currentCityId) : null
    return (cities ?? [])
        .filter((city) => city.flag_active || String(city.city_id) === currentId)
        .map((city) => ({
            value: String(city.city_id),
            label: city.flag_active ? city.city_name : `${city.city_name} (Inactive)`,
        }))
}
